import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';

const fallbackWords = {
  title: 'Descarga iniciada',
  description: 'Busca el instalador en el icono de descargas de Chrome, arriba a la derecha.',
  instruction: 'Al ubicar el archivo, haz clic en él para instalarlo.',
  blockedMessage: 'Si Chrome bloquea la apertura automatica, presiona',
  viewDownloads: 'Ver descargas',
  close: 'Cerrar',
};

export default function DownloadHint({ open, onClose, words = fallbackWords }) {
  const [showShortcut, setShowShortcut] = React.useState(false);
  const isMac = typeof navigator !== 'undefined' && /Mac/.test(navigator.platform);
  const downloadsShortcut = isMac ? 'Cmd + Shift + J' : 'Ctrl + J';

  React.useEffect(() => {
    if (open) {
      setShowShortcut(false);
    }
  }, [open]);

  if (!open) return null;

  const openDownloads = () => {
    setShowShortcut(true);
    window.open('chrome://downloads/', '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: { xs: 12, sm: 18 },
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2000,
        display: 'flex',
        justifyContent: 'center',
        width: { xs: 'calc(100% - 24px)', sm: 'auto' },
        pointerEvents: 'none',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: { xs: '100%', sm: 360 },
          maxWidth: 360,
          bgcolor: '#ffffff',
          border: '1px solid #d7ecff',
          borderRadius: '8px',
          boxShadow: '0 14px 35px rgba(2, 52, 92, 0.18)',
          px: 2,
          py: 1.5,
          pointerEvents: 'auto',
        }}
      >
        
        <Box sx={{ display: 'flex', gap: 1.25, alignItems: 'flex-start' }}>
          <FileDownloadDoneIcon sx={{ color: '#049dfb', mt: 0.25 }} />
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#12364f' }}>
              {words.title}
            </Typography>
            <Typography variant="body2" sx={{ color: '#4b6375', mt: 0.25, lineHeight: 1.35 }}>
              {words.description}
            </Typography>
            <Typography variant="body2" sx={{ color: '#4b6375',fontWeight:600, mt: 0.25, lineHeight: 1.35 }}>
              {words.instruction}
            </Typography>
            {showShortcut && (
              <Typography variant="body2" sx={{ color: '#12364f', mt: 1, lineHeight: 1.35, fontWeight: 600 }}>
                {words.blockedMessage} {downloadsShortcut}.
              </Typography>
            )}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1 }}>
          <Button
            size="small"
            onClick={openDownloads}
            sx={{ color: '#049dfb', fontWeight: 700 }}
          >
            {words.viewDownloads}
          </Button>
          <Button size="small" onClick={onClose} sx={{ color: '#6f7f8c', fontWeight: 700 }}>
            {words.close}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
